module.exports = __webpack_public_path__ + "ui-static/img/logo-large_dark.cbca52c1.svg";